import { AfterViewInit, Component, inject, Inject, isDevMode, OnInit, PLATFORM_ID, Signal } from '@angular/core';
import { CartComponent } from '../components/cart/cart.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { Store, Selector, Select } from '@ngxs/store';
import { AuthState, AuthStateModel } from '../state/auth.state';
import { Observable } from 'rxjs';
import { AuthActions } from '../state/auth.actions';
import { CartState } from '../state/cart.state';
import { isPlatformBrowser, JsonPipe } from '@angular/common';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser, faHome } from '@fortawesome/pro-solid-svg-icons';
import { faLayerGroup, faCircleUser } from "@awesome.me/kit-c6f1b0c8cf/icons/jelly/regular";
// import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-menu',
  imports: [CartComponent, RouterModule, JsonPipe, NgbTooltip, FontAwesomeModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  standalone: true
})
export class MenuComponent implements OnInit, AfterViewInit {
  private readonly gaService = inject(GoogleAnalyticsService);

  platform = inject(PLATFORM_ID);
  // _store = Inject(Store)

  // userIcon = faUser;
  // iconHome = faHome;
  // iconLayer = faLayerGroup;
  // userIconSlab = faCircleUser;

  toggleCategory = false;

  auth: Signal<boolean>;
  select: any;
  prueba: boolean = true;
  isDevMode: boolean = isDevMode();
  load = false;
  list = 'Empty';
  slug;

  constructor(
    private authService: AuthService,
    private store: Store,
    private activeRoute: ActivatedRoute,
    private icon: FaIconLibrary,
    @Inject(DOCUMENT) private document: Document
  ) {

    this.auth = this.store.selectSignal(AuthState.getAuth);
    
    // icon.addIcons(faCircleUser, faLayerGroup, faHome, faUser);


  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

    // this.load = true;
  }
  ngOnInit(): void {
    this.icon.addIcons(faCircleUser, faLayerGroup, faHome, faUser)

    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    // this.store.select(AuthActions.name)

    // this.auth = this.authService.getWithExpiry();
    //
    // this.auth = this.store.selectSignal(AuthState.getAuth)
    this.load = true;
    this.store.select(CartState.getList).subscribe((res) => {

      if (res.length <= 0) {
        
        this.list = 'Empty';
      } else {
        this.list = res.length;
      }


    });
  }
  scroll() {
    if (isPlatformBrowser(this.platform)) {
      this.document.defaultView?.scrollTo({ top: 0, behavior: 'smooth' });
    }

    this.toggleCategory = false;
  }
  toggle() {
    this.toggleCategory = !this.toggleCategory;
  }
}
